import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTachometerAlt, FaFileMedical, FaUserCog, FaUsers, FaCog, FaUserShield, FaMedal, FaChartBar } from "react-icons/fa";
import { useAuth } from '../hooks/useAuth';
import './Sidebar.css';
import VDCicon from '../assets/images/vdc_logo.png';

export default function Sidebar({ isExpanded, setIsExpanded }) {
     const [isHovered, setIsHovered] = useState(false);
     const { isAdmin, isSuperAdmin } = useAuth();
     const location = useLocation();
     const userData = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null;
     const role = userData ? userData.role : null;

     // Determine if sidebar should be shown as expanded
     const shouldShowExpanded = isExpanded || isHovered;

     // Helper function to check if a path is active
     const isActive = (path) => location.pathname === path;

     return (
          <div
               className={`sidebar ${shouldShowExpanded ? "expanded" : "collapsed"}`}
               onMouseEnter={() => setIsHovered(true)}
               onMouseLeave={() => setIsHovered(false)}
          >
               <div className="sidebar-brand">
                    <img style={{ width: '40px', height: '40px' }} src={VDCicon} alt="VDC Logo" className="vdc-logo" />
                    <span className="brand-text">Radiology TLD</span>
               </div>

               <ul className="sidebar-menu">
                    <li>
                         <Link
                              to="/dashboard"
                              className={`sidebar-menu-btn ${isActive('/dashboard') ? 'active' : ''}`}
                         >
                              <FaTachometerAlt className="menu-icon" />
                              <span className="menu-text">Dashboard</span>
                         </Link>
                    </li>

                    {/* only for technicians */}
                    {role === 'TECHNICIAN' && (
                         <li>
                              <Link
                                   to="/badges"
                                   className={`sidebar-menu-btn ${isActive('/badges') ? 'active' : ''}`}
                              >
                                   <FaMedal className="menu-icon" />
                                   <span className="menu-text">My Badges</span>
                              </Link>
                         </li>
                    )}

                    <li>
                         <Link
                              to="/sops"
                              className={`sidebar-menu-btn ${isActive('/sops') ? 'active' : ''}`}
                         >
                              <FaMedal className="menu-icon" />
                              <span className="menu-text">SOPs</span>
                         </Link>
                    </li>

                    {/* Submenu Example */}
                    {/* <li className="sidebar-submenu-parent">
                         <div className="sidebar-menu-btn">
                              <FaChartBar className="menu-icon" />
                              <span className="menu-text">Reports</span>
                         </div>
                         <ul className="sidebar-submenu">
                              <li>
                                   <Link
                                        to="/reports/summary"
                                        className={`sidebar-menu-btn ${isActive('/reports/summary') ? 'active' : ''}`}
                                   >
                                        <span className="menu-text">Summary</span>
                                   </Link>
                              </li>
                              <li>
                                   <Link
                                        to="/reports/detail"
                                        className={`sidebar-menu-btn ${isActive('/reports/detail') ? 'active' : ''}`}
                                   >
                                        <span className="menu-text">Detail</span>
                                   </Link>
                              </li>
                         </ul>
                    </li> */}

                    {/* Admin Only Menu Items */}
                    {isAdmin() && (
                         <>
                              <li className="menu-divider">
                                   <span className="menu-text">Administration</span>
                              </li>
                              {/* <li>
                                   <Link
                                        to="/admin"
                                        className={`sidebar-menu-btn ${isActive('/admin') ? 'active' : ''}`}
                                   >
                                        <FaUserShield className="menu-icon" />
                                        <span className="menu-text">Admin Panel</span>
                                   </Link>
                              </li> */}
                              <li>
                                   <Link
                                        to="/badge-cycles"
                                        className={`sidebar-menu-btn ${isActive('/badge-cycles') ? 'active' : ''}`}
                                   >
                                        <FaMedal className="menu-icon" />
                                        <span className="menu-text">Badge Cycles</span>
                                   </Link>
                              </li>
                              <li>
                                   <Link
                                        to="/badge-lists"
                                        className={`sidebar-menu-btn ${isActive('/badge-lists') ? 'active' : ''}`}
                                   >
                                        <FaMedal className="menu-icon" />
                                        <span className="menu-text">Badge Lists</span>
                                   </Link>
                              </li>
                              <li>

                                   <Link
                                        to="/dose-reports-list"
                                        className={`sidebar-menu-btn ${isActive('/dose-reports-list') ? 'active' : ''}`}
                                   >
                                        <FaFileMedical className="menu-icon" />
                                        <span className="menu-text">Dose Reports</span>
                                   </Link>
                              </li>

                              <li>
                                   <Link
                                        to="/technicians"
                                        className={`sidebar-menu-btn ${isActive('/technicians') ? 'active' : ''}`}
                                   >
                                        <FaUserCog className="menu-icon" />
                                        <span className="menu-text">Manage Technicians</span>
                                   </Link>
                              </li>

                              {isSuperAdmin() && (
                                   <li>
                                        <Link
                                             to="/users"
                                             className={`sidebar-menu-btn ${isActive('/users') ? 'active' : ''}`}
                                        >
                                             <FaUsers className="menu-icon" />
                                             <span className="menu-text">Manage Users</span>
                                        </Link>
                                   </li>
                              )}
                         </>
                    )}

                    {/* <li className="menu-divider">
                         <span className="menu-text">Settings</span>
                    </li>
                    <li>
                         <Link
                              to="/settings"
                              className={`sidebar-menu-btn ${isActive('/settings') ? 'active' : ''}`}
                         >
                              <FaCog className="menu-icon" />
                              <span className="menu-text">Settings</span>
                         </Link>
                    </li> */}
               </ul>
          </div>
     );
}

